import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=413bb5d2&scoped=true&"
import script from "./Matches.vue?vue&type=script&lang=js&"
export * from "./Matches.vue?vue&type=script&lang=js&"
import style0 from "./Matches.vue?vue&type=style&index=0&id=413bb5d2&lang=scss&scoped=true&"
import style1 from "./Matches.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413bb5d2",
  null
  
)

export default component.exports